import { render } from "./SplashSceen.vue?vue&type=template&id=2cb37d55"
import script from "./SplashSceen.vue?vue&type=script&lang=js"
export * from "./SplashSceen.vue?vue&type=script&lang=js"

import "./SplashSceen.vue?vue&type=style&index=0&id=2cb37d55&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-iframe-br/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__